import React from "react";
import {
  Card,
  Grid,
  Box,
  Typography,
  Avatar,
  IconButton,
  Chip,
  Tooltip,
  Stack,
  Rating,
} from "@mui/material";
import {
  Email,
  Phone,
  Flag,
  NewReleases,
  LockReset,
  Edit,
  Delete,
  WhatsApp,
  Notifications,
  CheckCircle,
  Cancel,
  BuildCircle,
  OutlinedFlag,
  LocalOffer,
  Warning,
  Task,
} from "@mui/icons-material";
import stringToColor from "../services/stringToColor";
import HandymanIcon from "@mui/icons-material/Handyman";
const ServiceProviderCard = ({
  provider,
  selected,
  onClick,
  onFlagged,
  onEdit,
  onDelete,
  onResetPassword,
  // onAssginmentService,
}) => {
  const {
    avatar_url,
    fullname,
    username,
    email,
    phone,
    rating,
    registrationsServiceType,
    complete_task,
    status,
    verified,
    isFlagged,
    compoundserviceType,
    compoundserviceType_logo,
  } = provider;
  const isNew = provider.status == "pending" ? true : false;
  // const isOffered = provider.compoundserviceType == "null";
  const isVerified = !provider.verify;
  return (
    <Card
      sx={{
        p: 2,
        position: "relative",
        borderRadius: 2,
        border: selected ? "2px solid #1976d2" : "1px solid #ccc",
        boxShadow: selected ? 4 : 1,
        transition: "all 0.2s ease-in-out",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {/* Top-right badges */}
      <Box
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        {isFlagged && (
          <Chip icon={<Flag />} label="Flagged" color="error" size="small" />
        )}
        {isNew && (
          <Chip icon={<NewReleases />} label="New" color="error" size="small" />
        )}
        {isVerified && (
          <Chip
            icon={<Warning />}
            label="Non-Verified"
            color="warning"
            size="small"
          />
        )}
      </Box>

      <Grid container spacing={5}>
        {/* Avatar + Info */}
        <Grid item xs={12} sm={4} md={3}>
          <Stack alignItems="center">
            {avatar_url ? (
              <Avatar
                src={avatar_url}
                sx={{ width: 64, height: 64 }}
                className="notranslate"
              />
            ) : (
              <Avatar
                className="notranslate"
                sx={{
                  width: 64,
                  height: 64,
                  bgcolor: stringToColor(username),
                }}
              >
                {username.charAt(0).toUpperCase()}
              </Avatar>
            )}

            <Typography
              variant="subtitle1"
              fontWeight="bold"
              mt={1}
              className="notranslate"
            >
              {username}
            </Typography>
            <Chip
              icon={status === "active" ? <CheckCircle /> : <Cancel />}
              label={
                status === "active"
                  ? "Active"
                  : status === "pending"
                  ? "Pending"
                  : "Inactive"
              }
              color={
                status === "active"
                  ? "success"
                  : status === "pending"
                  ? "primary"
                  : "error"
              }
              size="small"
              sx={{ mt: 2, width: "fit-content" }}
            />
            {/* Contact info below avatar */}
          </Stack>
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <Box mt={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Rating
                value={rating ?? 0}
                precision={0.5}
                readOnly
                size="large"
                sx={{ mt: 0.5 }}
              />
              <Typography variant="body2">{rating}</Typography>
              <Task />
              <Typography variant="body2">{complete_task}</Typography>
            </Stack>

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              className="notranslate"
            >
              <Email sx={{ fontSize: 18 }} />
              <Typography variant="body2">{email}</Typography>
            </Stack>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              mt={0.5}
              className="notranslate"
            >
              <Phone sx={{ fontSize: 18 }} />
              <Box dir="ltr">
                <Typography variant="body2">{phone}</Typography>
              </Box>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <Box mt={4}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar>
                <HandymanIcon />
              </Avatar>
              <Typography variant="h5">
                {compoundserviceType == "null"
                  ? registrationsServiceType
                  : compoundserviceType}
              </Typography>
            </Stack>
          </Box>
        </Grid>
        {/* Bottom-right action buttons */}
        <Box
          sx={{
            position: "absolute",
            bottom: 8,
            right: 8,
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <Tooltip title="setFlag">
              <IconButton
                color="success"
                onClick={(e) => {
                  e.stopPropagation();
                  onFlagged(provider);
                }}
              >
                {provider.isFlagged ? <Flag /> : <OutlinedFlag />}
              </IconButton>
            </Tooltip>
            {/* 
            <Tooltip title="Assign the Service">
              <IconButton
                color="info"
                onClick={(e) => {
                  e.stopPropagation();
                  onAssginmentService(provider);
                }}
              >
                <LocalOffer />
              </IconButton>
            </Tooltip> */}
            {/* <Tooltip title="Reset Password">
              <IconButton
                color="warning"
                onClick={(e) => {
                  e.stopPropagation();
                  onResetPassword(provider);
                }}
              >
                <LockReset />
              </IconButton>
            </Tooltip> */}

            <Tooltip title="Edit">
              <IconButton
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(provider);
                }}
              >
                <Edit />
              </IconButton>
            </Tooltip>

            <Tooltip title="Delete">
              <IconButton
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(provider);
                }}
              >
                <Delete />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      </Grid>
    </Card>
  );
};

export default ServiceProviderCard;
